<mat-drawer-container class="custom-sidenav-drawer" hasBackdrop="isBackdrop">
  <mat-drawer #drawer class="custom-sidenav" [disableClose]="true" [mode]="drawerMode" [position]="drawerPosition">
    <div class="drawer-container">
      @if (showCloseButton) {
      <div class="close-button">
        <button aria-label="Close" class="bg-white-button" data-qa="close-button" disableRipple="true" mat-icon-button
          (click)="onDrawerClosed()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      }
      <h5>{{title}}</h5>
    </div>
    @if (componentName === ComponentName.Comments) {
      @for (comment of comments; track comment.id;) {
        <app-comment [comment]="comment"></app-comment>
      }
    } @else {
      <ng-container #container></ng-container>
    }
  </mat-drawer>
</mat-drawer-container>